import MuiTypography from '@mui/material/Typography';
import { Box, Grid } from '@mui/material';
import { makeStyles, withStyles } from '@mui/styles';
import { Link } from 'react-router-dom';
import BlockContainer from '../../components/GridContainer';

const Typography = withStyles((theme) => ({
  root: {
    marginBottom: 15,
  },
  subtitle1: {
    fontWeight: 'bold',
    paddingTop: '15px',
  },
  subtitle2: {
    fontWeight: 'bold',
    size: '1rem',
    lineHeight: 1.5,
  },
  subtitle3: {
    fontWeight: 'bold',
  },
}))(MuiTypography);

const useStyles = makeStyles((theme) => ({
  box: {
    backgroundColor: 'white',
    padding: 15,
    '& > ul li': {
      fontSize: '1rem',
    },
  },
  table: {
    backgroundColor: theme.palette.secondary.morelight,
  },
  title: {
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: theme.palette.primary.main,
    margin: 20,
  },
  boxWhite: {
    padding: '20px 20px',
    minHeight: '120px',
    backgroundColor: theme.palette.primary.plusLight,
  },
  boxGrey: {
    padding: '20px 20px',
    minHeight: '120px',
    backgroundColor: theme.palette.secondary.light,
  },
  text: {
    textTransform: 'uppercase',
    color: theme.palette.secondary.dark,
    fontWeight: 'bold',
  },
  boxContainer: {
    width: '100%',
    padding: 10,
    backgroundColor: 'white',
  },
  orange: {
    padding: 3,
    height: '100%',
    backgroundColor: theme.palette.primary.light,
  },
  grey: {
    padding: 3,
    height: '100%',
    backgroundColor: theme.palette.secondary.light,
  },
  cont: {
    '& a': {
      color: theme.palette.primary.main,
      textDecoration: 'none',
    },
    '& ul': {
      listStyle: 'none',
      fontSize: '1rem',
      marginLeft: -20,
      '&  li': {
        fontSize: '0.93rem',
        '&:before': {
          color: theme.palette.primary.main,
          content: '"\\2022"',
          fontWeight: 'bold',
          display: 'inline-block',
          width: '1em',
        },
      },
    },
  },
  assonave: {
    color: theme.palette.primary.main,
    fontSize: 'bold',
  },
}));

const PrivacyPolicy = () => {
  const classes = useStyles();
  const LinkAssonave = ({ translation }) => {
    return (
      <a target="_blank" rel="noreferrer" href="https://www.assonave.it">
        {translation}
      </a>
    );
  };

  const rightsOfDataSubjects = [
    {
      first: (
        <>
          <Typography variant="body1">Diritto di accesso:</Typography>
          <Typography variant="caption">(art. 15 del Regolamento)</Typography>
        </>
      ),
      second: (
        <>
          <Typography variant="body1">
            ovvero conferma che sia o meno in corso un trattamento di dati
            personali , che La riguardano e in tal caso, diritto di ottenere,
            fra l’altro, l'accesso ai Suoi dati personali e alle informazioni
            inerenti le finalità del trattamento, le categorie di dati personali
            in questione, i destinatari o le categorie di destinatari a cui i
            dati personali sono stati o saranno comunicati.
          </Typography>
        </>
      ),
    },
    {
      first: (
        <>
          <Typography variant="body1">Diritto di rettifica:</Typography>
          <Typography variant="caption">(art. 16 del Regolamento)</Typography>
        </>
      ),
      second: (
        <>
          <Typography variant="body1">
            (i) rettifica dei dati personali inesatti che La riguardano senza
            ingiustificato ritardo e (ii) integrazione dei Suoi dati personali,
            se incompleti.
          </Typography>
        </>
      ),
    },
    {
      first: (
        <>
          <Typography variant="body1">
            "Diritto alla cancellazione («diritto all'oblio»):
          </Typography>
          <Typography variant="caption">(art. 17 del Regolamento)</Typography>
        </>
      ),
      second: (
        <>
          <Typography variant="body1">
            Diritto alla cancellazione («diritto all'oblio»): (art. 17 del
            Regolamento) cancellazione dei dati personali che La riguardano
            senza ingiustificato ritardo (il Titolare del trattamento ha
            l'obbligo di cancellare senza ingiustificato ritardo i dati
            personali nei casi previsti dall’articolo 17 del Regolamento).
          </Typography>
        </>
      ),
    },
    {
      first: (
        <>
          <Typography variant="body1">
            Diritto di limitazione di trattamento:
          </Typography>
          <Typography variant="caption">(art. 18 del Regolamento)</Typography>
        </>
      ),
      second: (
        <>
          <Typography variant="body1">
            limitazione del trattamento nei casi di cui all’articolo 18 del
            Regolamento.
          </Typography>
        </>
      ),
    },
    {
      first: (
        <>
          <Typography variant="body1">
            Diritto alla portabilità dei dati:
          </Typography>
          <Typography variant="caption">(art. 20 del Regolamento)</Typography>
        </>
      ),
      second: (
        <>
          <Typography variant="body1">
            ricevimento in un formato strutturato, di uso comune e leggibile da
            dispositivo automatico, dei dati personali che La riguardano e in
            nostro possesso; diritto di trasmettere tali dati a un altro
            titolare del trattamento senza impedimenti da parte del titolare del
            trattamento cui li ha forniti nei casi di cui all’articolo 20 del
            Regolamento.
          </Typography>
        </>
      ),
    },
    {
      first: (
        <>
          <Typography variant="body1">
            Diritto di opposizione per trattamenti eseguiti ai sensi
            dell’articolo 6, paragrafo 1 lettere e) o f):
          </Typography>
          <Typography variant="caption">(art. 21 del Regolamento)</Typography>
        </>
      ),
      second: (
        <>
          <Typography variant="body1">
            opposizione, in qualsiasi momento, per motivi connessi alla Sua
            situazione particolare, al trattamento dei dati personali che la
            riguardano ai sensi dell’articolo 6, paragrafo 1 lettere e) o f)
            compresa la profilazione sulla base di tali disposizioni.
          </Typography>
        </>
      ),
    },
  ];

  return (
    <BlockContainer>
      <Grid
        container
        alignItems="center"
        direction="column"
        wrap="wrap"
        spacing={1}
        className={classes.cont}
      >
        <Typography className={classes.title} variant="h4">
          INFORMATIVA PRIVACY DEL SITO WEB
        </Typography>
        <Box className={classes.box}>
          <Typography>
            Assonave, in qualità di titolare del trattamento dei dati, fornisce
            l’informativa riguardante il trattamento dei dati personali degli
            Utenti che consultano il sito.
            <LinkAssonave translation={'www.assonave.it'} />
            (“Sito”) ai sensi dell’art. 13 del Regolamento EU n. 679/2016
            (“Regolamento” o “GDPR”).
          </Typography>
          <Typography>
            La presente informativa è resa solo per il Sito e non anche per
            altri siti web eventualmente consultabili dall’utente tramite link.
          </Typography>
          <Typography variant="subtitle1">
            1. TITOLARE DEL TRATTAMENTO DEI DATI PERSONALI
          </Typography>
          <Typography>
            Il Titolare del trattamento dei Suoi dati personali raccolti
            nell’ambito dell’utilizzo del sito web è Assonave, con sede legale
            in Via Tevere, 1/a 00198 - Roma (RM), (di seguito anche solo il
            “Titolare”), indirizzo email
            <a
              target="_blank"
              rel="noreferrer"
              href="mailto:privacy@assonave.it"
            >
              privacy@assonave.it
            </a>
            , tel. +39 0684514229.
          </Typography>
          <Typography variant="subtitle1">
            2. TIPOLOGIE DI DATI, FINALITÀ E BASE GIURIDICA DEL TRATTAMENTO DEI
            DATI
          </Typography>
          <Typography>
            Attraverso il Sito potranno essere raccolte le seguenti categorie di
            dati personali:
          </Typography>
          <Typography variant="subtitle1">
            <strong>a) Dati di navigazione:</strong>i sistemi informatici e le
            procedure software preposte al funzionamento del Sito acquisiscono,
            nel corso del loro normale esercizio, alcuni dati la cui
            trasmissione è implicita nell'uso dei protocolli di comunicazione di
            Internet.
          </Typography>
          <Typography>
            Si tratta di informazioni che non sono raccolte per essere associate
            a interessati identificati, ma che per loro stessa natura
            potrebbero, attraverso elaborazioni ed associazioni con dati
            detenuti da terzi, permettere di identificare gli utenti.
          </Typography>
          <Typography>
            In questa categoria di dati possono rientrare gli indirizzi IP o i
            nomi a dominio dei computer utilizzati dagli utenti che si
            connettono al sito, gli indirizzi in notazione URI (Uniform Resource
            Identifier) delle risorse richieste, l'orario della richiesta, il
            metodo utilizzato nel sottoporre la richiesta al server, la
            dimensione del file ottenuto in risposta, il codice numerico
            indicante lo stato della risposta data dal server (buon fine,
            errore, ecc.) ed altri parametri relativi al sistema operativo e
            all'ambiente informatico dell'utente.
          </Typography>
          <Typography>
            Questi dati vengono utilizzati al solo fine di ricavare informazioni
            statistiche anonime sull'uso del sito e per controllarne il corretto
            funzionamento del Sito.
          </Typography>
          <Typography variant="subtitle1">
            <strong>b) Dati forniti volontariamente dall’utente,</strong>
            in particolare:
          </Typography>
          <Typography>
            dati anagrafici, di contatto, professionali, conferiti mediante
            compilazione del modulo di
            <strong>iscrizione all’Associazione Assonave</strong>, al fine di
            riscontrare la richiesta di iscrizione e svolgere le attività
            necessarie al suo perfezionamento; "nome, indirizzo e-mail ed
            eventuali altri dati personali conferiti mediante la compilazione
            del form per
            <strong>l’iscrizione all’Area riservata del Sito; </strong>
            nome e indirizzo e-mail per
            <strong>iscrizione al servizio di newsletter informativa</strong>,
            relativa a comunicazioni periodiche e approfondimenti in materie di
            interesse per l’industria navalmeccanica italiana e per gli
            Associati.
          </Typography>
          <Typography>
            I trattamenti sono necessari per l’esecuzione degli obblighi
            contrattuali e/o di legge in capo al Titolare in ragione delle
            richieste dell’utente ovvero vengono effettuati sulla base del
            legittimo interesse del Titolare.
          </Typography>

          <Typography variant="subtitle1">3. COOKIE</Typography>

          <Typography>
            Il Sito fa uso di cookie così come meglio specificato nella relativa
            cookie policy consultabile al seguente link
            <Link target="_blank" to={{ pathname: '/policies/cookie' }}>
              www.assonave.it/policies/cookie
            </Link>
          </Typography>
          <Typography variant="subtitle1">
            4. DESTINATARI DEI DATI PERSONALI
          </Typography>
          <Typography>
            I Suoi dati personali non saranno comunicati a terzi, ad eccezione
            dei fornitori coinvolti nelle attività summenzionate e comunque
            sempre in stretta relazione e compatibilmente alle finalità sopra
            esposte.
          </Typography>

          <Typography variant="subtitle1">
            5. TRASFERIMENTO DEI DATI PERSONALI AD UN PAESE TERZO O AD
            UN’ORGANIZZAZIONE INTERNAZIONALE
          </Typography>
          <Typography>
            Il Titolare non effettua il trasferimento dei Suoi dati personali
            verso paesi non appartenenti all’Unione Europea.
          </Typography>

          <Typography variant="subtitle1">
            6. PERIODO DI CONSERVAZIONE DEI DATI PERSONALI
          </Typography>
          <Typography>
            I Suoi dati saranno conservati per il tempo pari alla durata
            dell’erogazione dei servizi richiesti. Per cancellare o disabilitare
            i cookies si veda
            <Link target="_blank" to={{ pathname: '/policies/cookie' }}>
              www.assonave.it/policies/cookie
            </Link>
          </Typography>

          <Typography variant="subtitle1">
            7. NATURA DEL CONFERIMENTO DEI DATI E CONSEGUENZA IN CASO DI MANCATO
            CONFERIMENTO DEGLI STESSI
          </Typography>
          <Typography>
            I dati di navigazione raccolti sono necessari per permettere
            all’interessato la navigazione sul Sito.
          </Typography>
          <Typography>
            I dati conferiti volontariamente dall’utente sono necessari per
            l’iscrizione ai servizi dell’Associazione.
          </Typography>

          <Typography variant="subtitle1">
            8. DIRITTI DELL’INTERESSATO
          </Typography>
          <Typography>
            La informiamo che, in quanto interessato al trattamento, Lei ha il
            diritto di ottenere dal Titolare del trattamento:
          </Typography>

          {rightsOfDataSubjects &&
            rightsOfDataSubjects.map((el, idx) => (
              <Grid container className={classes.containerBox} key={idx}>
                <Grid item xs={5} md={4}>
                  <Box
                    className={`${
                      idx % 2 === 0 ? classes.orange : classes.grey
                    } ${classes.table}`}
                  >
                    {el.first}
                  </Box>
                </Grid>
                <Grid item xs={7} md={8}>
                  <Box
                    className={idx % 2 === 0 ? classes.orange : classes.grey}
                  >
                    {el.second}
                  </Box>
                </Grid>
              </Grid>
            ))}
          <Typography>
            In ogni momento Lei avrà la possibilità di avvalersi dei diritti
            sopracitati mediante una richiesta inviata al seguente indirizzo
            e-mail:
            <a
              target="_blank"
              rel="noreferrer"
              href="mailto:privacy@assonave.it"
            >
              privacy@assonave.it
            </a>
          </Typography>
          <Typography>
            Lei, inoltre, ha diritto di proporre reclamo al Garante per la
            Protezione dei dati personali nel caso in cui ritenesse che il
            trattamento che La riguarda violi quanto prescritto dal Regolamento
            EU n. 679/2016.
          </Typography>
        </Box>
      </Grid>
    </BlockContainer>
  );
};

export default PrivacyPolicy;
